// src/components/store/sections/gallery/GalleryV37InstagramsquareOceanCyan.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV37InstagramsquareOceanCyan(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={37}
      archKey="instagram_square"
      archLabel="Instagram Square Grid"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
